import { render, staticRenderFns } from "./Investigation.vue?vue&type=template&id=0aa5055a&scoped=true&"
import script from "./Investigation.vue?vue&type=script&lang=js&"
export * from "./Investigation.vue?vue&type=script&lang=js&"
import style0 from "./Investigation.vue?vue&type=style&index=0&id=0aa5055a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa5055a",
  null
  
)

export default component.exports